import React from 'react';
import Modal from '@synergycms_core/components/generic/Modal';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import {RichText} from '@synergycms_core/components/generic';
import { compose } from "ramda";
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const PoliciesModal = props => {
  let prevPenaltyNR = false;
  const { classes } = props.theme.styles;

  return (
    <Modal
      innerStyle={['modalStyle']}
      contentStyle={classes.availModalcontent}
      closeButtonStyle={classes.closeButton}
      modalStyle={classes.hotelModalStyle}
      popover={
        <div className={classes.modalTabsList}>
          <div className={classes.headerModal}>
            <RichText
              innerStyle={classes.modalTitle}
              text={'_%condiciones de la tarifa%_'}
              translate={true}
              ucFirst={true}
            />
          </div>
          <div className={classes.titleListBlock}>
            {props.penalties.map((penalty, key) => {
              if (penalty.nr === true) {
                prevPenaltyNR = true;
              }
              if (penalty.pms === 'FlexMyRoom') {
                return (
                  (key === 0 || !prevPenaltyNR) && (
                    <div key={key}>
                      <RichText
                        innerStyle={['roboto13Black']}
                        dangerouslySetInnerHTML={'_%flexmyroom_front_text%_'}
                        translate={true}
                      />
                    </div>
                  )
                );
              } else {
                return (
                  (key === 0 || !prevPenaltyNR) && (
                    <div key={key}>
                      <RichText
                        translate={true}
                        text={penalty.text}
                        withVars={penalty}
                        ucFirst={true}
                        innerStyle={['roboto13Black']}
                        dangerouslySetInnerHTML={true}
                      />                      
                    </div>
                  )
                );
              }
            })}
            {props.requiredPrepaymentText && props.requiredPrepaymentText.length > 0 && <div>
              <br/>
              <RichText
                text={props.requiredPrepaymentText}
                innerStyle={['roboto13Black']}
              />
            </div>}
          </div>
        </div>
      }
      typeModal={'roomDetailTooltip'}>
      <div className={classes.policiesTextToggle}>
        <RichText
          translate={true}
          innerStyle={['gold', classes.politicsText]}
          text={'_%las condiciones de la tarifa%_'}
        />
      </div>
    </Modal>
  );
};

export default compose(withThemeJSS({ styleFile, link: true, index: 200, displayName: 'PoliciesModal' }))(PoliciesModal);
